import React, { useContext, useEffect, useState } from "react";
import {
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import { Cancel, Save } from "../../../Shared/Constants";
import { useForm } from "react-hook-form";
import InputError from "../../../Shared/Components/Form/InputError";

import { togleLoading } from "../../../Shared/Utils/alertLoading";
import CityContext from "../Context/Index";
import CustomSelect from "../../../Shared/Components/Form/CustomSelect";
import { getProvincesApi } from "../../../Shared/Api/GetProvinces";

export default function CityForm() {
  const [provinces, setProvinces] = useState([]);
  //context
  const {
    createItem,
    apiErrors,
    modalTogle,
    showModal,
    item,
    updateItem,
    saving,
  } = useContext(CityContext);
  //form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm();

  const onSubmit = (data) => {
    if (item && item?.id) {
      updateItem(data, item?.id);
    } else {
      createItem(data);
    }
  };

  //set default values to form
  useEffect(() => {
    reset({
      name: item?.name,
      type: item?.type,
    });

    setValue("province_id", item?.province_id);
  }, [item]);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  const fetchProvinces = async () => {
    let response = await getProvincesApi();
    if (response.result === "success") {
      setProvinces(response.data?.items);
    }
  };

  useEffect(() => {
    fetchProvinces();
  }, []);
  return (
    <Form onSubmit={handleSubmit(onSubmit)} id="citiesForm">
      <Modal
        isOpen={showModal}
        toggle={modalTogle}
        className="rounded-1"
        size="lg"
      >
        <ModalHeader toggle={modalTogle}>
          <div>
            <H3
              attrH3={{
                className: "modal-title",
                id: "exampleModalLabel1",
              }}
            >
              {item?.id ? "Modificar Ciudad" : "Agregar Ciudad"}
            </H3>
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="name" className="form-label">
                  Nombre
                </Label>
                <input
                  className="form-control"
                  type="text"
                  required=""
                  placeholder="Ingresa el nombre de la ciudad"
                  autoComplete="off"
                  {...register("name", {
                    required: "El nombre es obligatorio",
                  })}
                />
                <InputError errors={errors} name="name" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label htmlFor="type" className="form-label">
                  Provincia
                </Label>
                <CustomSelect
                  items={provinces}
                  name={"province_id"}
                  setValue={setValue}
                  placeholder="Seleccione"
                  errors={errors}
                  register={register}
                  item={item}
                />
                <InputError errors={errors} name="type" />
              </FormGroup>
            </Col>
          </Row>
          <Btn
            attrBtn={{
              color: "secondary",
              className: "ms-1",
              onClick: modalTogle,
            }}
          >
            {Cancel}
          </Btn>
          <Btn
            attrBtn={{
              type: "submit",
              form: "citiesForm",
              className: "ms-1",
              color: `${isDirty ? "primary" : "secondary"}`,
              disabled: !isDirty,
            }}
          >
            {Save}
          </Btn>
        </ModalBody>
      </Modal>
    </Form>
  );
}
